import React, { useEffect, useState, lazy } from 'react';
export const CTAButton = ({
  children,
  href = '#precio',
  className = '',
  variant = 'primary'
}: {
  children: React.ReactNode;
  href?: string;
  className?: string;
  variant?: 'primary' | 'outline';
}) => {
  return <a href={href} className={`inline-flex items-center justify-center px-8 py-4 rounded-lg font-bold uppercase transition-all duration-300 text-center cta-shadow cta-animated ${variant === 'primary' ? 'bg-familia-cyan text-familia-bg hover:bg-familia-coral/90' : 'border-2 border-familia-cyan text-familia-cyan hover:bg-familia-cyan/10'} ${className}`} data-id="element-194">
      {children}
    </a>;
};
export const Countdown = ({
  className = ''
}: {
  className?: string;
}) => {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 54,
    s: 20
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return {
          h: 23,
          m: 59,
          s: 59
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (n: number) => n.toString().padStart(2, '0');
  return <div className={`flex justify-center items-start gap-2 sm:gap-4 font-mono text-2xl sm:text-4xl md:text-6xl font-bold text-familia-cyan w-full ${className}`} data-id="element-195">
      <div className="flex flex-col items-center" data-id="element-196">
        <div className="bg-familia-card border border-familia-cyan/30 px-3 py-2 sm:p-3 rounded-lg min-w-[60px] sm:min-w-[80px] text-center" data-id="element-197">
          [{format(timeLeft.h)}]
        </div>
        <span className="text-[10px] sm:text-xs text-familia-gray mt-2 uppercase font-sans" data-id="element-198">
          horas
        </span>
      </div>
      <div className="pt-2 sm:pt-4" data-id="element-199">:</div>
      <div className="flex flex-col items-center" data-id="element-200">
        <div className="bg-familia-card border border-familia-cyan/30 px-3 py-2 sm:p-3 rounded-lg min-w-[60px] sm:min-w-[80px] text-center" data-id="element-201">
          [{format(timeLeft.m)}]
        </div>
        <span className="text-[10px] sm:text-xs text-familia-gray mt-2 uppercase font-sans" data-id="element-202">
          minutos
        </span>
      </div>
      <div className="pt-2 sm:pt-4" data-id="element-203">:</div>
      <div className="flex flex-col items-center" data-id="element-204">
        <div className="bg-familia-card border border-familia-cyan/30 px-3 py-2 sm:p-3 rounded-lg min-w-[60px] sm:min-w-[80px] text-center" data-id="element-205">
          [{format(timeLeft.s)}]
        </div>
        <span className="text-[10px] sm:text-xs text-familia-gray mt-2 uppercase font-sans" data-id="element-206">
          segundos
        </span>
      </div>
    </div>;
};
export const PriceCard = () => {
  const items = ['Módulo 1: Young Learners (Ages 6-11)', 'Módulo 2: Teens Bridge (Ages 12-17)', 'Módulo 3: Grammar Sin Vueltas (A1-B1)', 'Bono 1: Flashcards Bilingües (200 tarjetas)', 'Bono 2: Speaking Cards (50 tarjetas)', 'Bono 3: Planificación Express 30 días', 'Sistema Espejo EN + ES en todo el pack', 'Pronunciación en todas las páginas', 'Respuestas para padres en cada módulo', '3 Mock Tests con grilla de corrección', '3 Progress Trackers visuales', '+500 páginas de contenido bilingüe'];
  return <div className="bg-familia-section border-2 border-familia-gold rounded-2xl p-6 sm:p-10 shadow-[0_0_30px_-12px_rgba(242,181,68,0.5)] sm:shadow-[0_0_50px_-12px_rgba(242,181,68,0.4)] max-w-2xl mx-auto relative overflow-hidden" data-id="element-207">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 bg-familia-gold text-familia-bg font-bold text-xs py-1 px-4 rounded-b-lg uppercase" data-id="element-208">
        ⭐ SISTEMA COMPLETO 2025
      </div>

      <div className="text-center mt-4 mb-8" data-id="element-209">
        <h3 className="text-2xl font-display font-bold mb-1" data-id="element-210">
          English en Familia™
        </h3>
        <p className="text-familia-gray text-sm uppercase tracking-widest" data-id="element-211">
          Mega Pack Bilingüe Cambridge · Pack Completo
        </p>
      </div>

      <div className="flex items-center gap-4 mb-8 bg-familia-card/60 p-4 rounded-xl border border-white/5" data-id="element-212">
        <img src="https://cdn.magicpatterns.com/uploads/1gogxkHTXKLRUBaowas8sp/hf_20260522_191029_7a20001b-07c9-47a6-aa30-37cdc35dcae1-removebg-preview.png" alt="English en Familia Mega Pack Bilingüe Cambridge" width="96" height="96" loading="lazy" decoding="async" className="w-24 h-24 object-contain drop-shadow-lg" data-id="element-213" />
        <div className="flex flex-col items-start" data-id="element-214">
          <span className="text-familia-red line-through text-lg mb-1" data-id="element-215">
            $85.000 ARS
          </span>
          <span className="text-familia-cyan text-4xl font-bold" data-id="element-216">
            $19.990 ARS
          </span>
        </div>
      </div>

      <CTAButton href="https://checkout.guiadigital360.online/cart/45042442436677:1" className="w-full text-xl py-6 mb-6" data-id="element-217">
        →LO QUIERO AHORA
      </CTAButton>

      <div className="flex flex-wrap justify-center gap-4 text-[10px] sm:text-xs text-familia-gray mb-8" data-id="element-218">
        <span data-id="element-219">🔒 Pago seguro</span>
        <span data-id="element-220">⚡ Acceso en 5 min</span>
        <span data-id="element-221">🛡️ Garantía 7 días</span>
        <span data-id="element-222">🇦🇷 Argentina</span>
      </div>

      <div className="space-y-3 border-t border-white/10 pt-8" data-id="element-223">
        {items.map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-224">
            <span className="text-familia-green text-lg" data-id="element-225">✅</span>
            <span className="text-sm sm:text-base font-medium" data-id="element-226">{item}</span>
          </div>)}
      </div>

      <p className="text-center text-familia-gray text-xs mt-8" data-id="element-227">
        Pago único · Sin suscripciones mensuales · Acceso de por vida
      </p>
    </div>;
};